import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion, useScroll, useMotionValueEvent, AnimatePresence } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export const CTAButton = ({ to = "/alta", children = "DARME DE ALTA", variant = "primary", testid, className = "" }) => {
  const base =
    "group inline-flex items-center gap-3 font-mono text-xs tracking-[0.25em] px-8 py-4 transition-colors duration-300 select-none";
  const styles =
    variant === "primary"
      ? "bg-silver text-night hover:bg-offwhite"
      : "border border-silver/30 text-silver hover:border-silver hover:text-offwhite";
  return (
    <motion.span whileHover={{ y: -2 }} whileTap={{ scale: 0.97 }} className="inline-block">
      <Link to={to} data-testid={testid} className={`${base} ${styles} ${className}`}>
        <span>{children}</span>
        <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </Link>
    </motion.span>
  );
};

export const StickyCTA = () => {
  const { scrollY } = useScroll();
  const [show, setShow] = useState(false);
  const { pathname } = useLocation();
  useMotionValueEvent(scrollY, "change", (v) => setShow(v > 650));
  const visible = show && !pathname.startsWith("/alta");
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-0 inset-x-0 z-50 md:hidden"
          data-testid="sticky-cta-bar"
        >
          <Link
            to="/alta"
            data-testid="sticky-cta-alta"
            className="flex items-center justify-between bg-silver text-night px-6 py-4 font-mono text-xs tracking-[0.25em]"
          >
            <span>DARME DE ALTA</span>
            <ArrowUpRight className="h-4 w-4" />
          </Link>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
